// extracted by mini-css-extract-plugin
export default {"wrapper":"Privacy_wrapper__QF+GU","button":"Privacy_button__XTgwt","content":"Privacy_content__TDD7I","title":"Privacy_title__vcR-e"};